import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import VHInfoPopup from '@vh/components/VHInfoPopup/VHInfoPopup';
import { setMoreInfoVisible } from '@vh/slices/vh-player/VHPlayerSlice';
import { selectAudioToPlay } from '@vh/slices/chat/ChatSlice';
import useFeature from '@core/components/LaunchDarkly';
import LegacyVHInfoPopup from '@vh/components/VHInfoPopup/LegacyVHInfoPopup';

/**
 * @type {React.FC<{onLoaded: () => void; vhId: number; }>}
 */
const DevVHPlayer = ({ onLoaded, vhId }) => {
  const dispatch = useDispatch();
  const audioToPlay = useSelector(selectAudioToPlay);
  console.log(audioToPlay);

  const setReadyToStart = useCallback(() => {
    dispatch(setMoreInfoVisible(true));
  }, [dispatch]);

  useEffect(() => {
    if (onLoaded) {
      onLoaded();
      setReadyToStart();
    }
  }, [onLoaded, setReadyToStart]);

  const showSelectableUserLanguageFeature = useFeature(
    'show-selectable-user-language'
  );

  return (
    <div>
      {showSelectableUserLanguageFeature ? (
        <VHInfoPopup vhId={vhId} />
      ) : (
        <LegacyVHInfoPopup vhId={vhId} />
      )}
    </div>
  );
};

export default DevVHPlayer;
